<script setup lang="ts">
import { computed } from 'vue'

import UigIcon from '@/components/UigIcon.vue'
import { useGenerationsStore } from '@/stores/generations'

const generations = useGenerationsStore()
const latest = computed(() => generations.active.at(-1))
</script>

<template>
  <button
    v-if="latest"
    class="generation-indicator"
    type="button"
    :aria-label="`${generations.activeCount} generating. View progress`"
    @click="generations.openViewer(latest.id)"
  >
    <UigIcon
      name="sparkles"
      :size="15"
    />
    <span>{{ generations.activeCount }} generating</span>
  </button>
</template>
